<template>
  <component
    :is="mapType[type]"
    v-bind="componentProps"
    @ready="ready"
    @onBlur="$emit('onBlur')"
    @onClick="$emit('onClick')"
    @onFocusEditor="$emit('onFocusEditor')"
    @rich-text-editor-update="onRichTextEditorUpdate"
    :disabled="disabled"
  ></component>
</template>

<script>

import _ from 'lodash'

export default {
  name: 'BlockEditor',
  components: {
    RichTextEditor: () => import('./RichTextEditor.v2.vue'),
    ImageEditor: () => import('./ImageEditor.vue'),
    EmojiEditor: () => import('./EmojiEditor.vue'),
    ShapeEditor: () => import('./ShapeEditor.vue'),
    LineEditor: () => import('./LineEditor.vue'),
  },
  props: {
    type: {
      type: String,
      default: null,
    },
    componentData: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    preview: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mapType: {
        RichText: 'RichTextEditor',
        Image: 'ImageEditor',
        Emoji: 'EmojiEditor',
        Shape: 'ShapeEditor',
        Line: 'LineEditor',
      },
    }
  },
  computed: {
    componentProps() {
      let transformData = { }
      const transformDataFunc = this[`transformDataType${this.type}`]
      if (transformDataFunc) {
        transformData = transformDataFunc()
      }

      return {
        ...transformData,
        blockContent: _.get(this.componentData, 'content'),
        blockStyle: {
          width: _.get(this.componentData, 'style.width'),
          height: _.get(this.componentData, 'style.height'),
          zIndex: this.componentData.index,
          minHeight: _.get(this.componentData, 'style.minHeight') || this.minHeight,
          transform: _.get(this.componentData, 'style.transform'),
        },
        animation: _.get(this.componentData, 'content.animation'),
        isInfinity: _.get(this.componentData, 'content.isInfinity'),
        duration: _.get(this.componentData, 'content.duration'),
        alt: _.get(this.componentData, 'content.alt'),
        blockId: this.componentData.id,
        slideId: this.componentData.slideId,
        preview: this.preview,
      }
    },
    minHeight() {
      if (this.type === 'RichText') {
        return '90px'
      }
      if (this.type === 'Emoji') {
        return '54px'
      }
      if (this.type === 'Line') {
        return '2px'
      }
      return '20px'
    },
  },
  methods: {
    transformDataTypeRichText() {
      return {
        value: _.get(this.componentData, 'content.value'),
      }
    },
    transformDataTypeImage() {
      return _.get(this.componentData, 'content')
    },
    transformDataTypeEmoji() {
      return _.get(this.componentData, 'content')
    },
    transformDataTypeShape() {
      return _.get(this.componentData, 'content')
    },

    onRichTextEditorUpdate(textUpdate) {
      this.$emit('update-content', {
        value: textUpdate,
      })
    },

    ready(slideId) {
      this.$emit('ready', slideId)
    },
  },
}
</script>
